import { observer } from "mobx-react";
import { ApproveAuditorRemunerationForm } from "./approveAuditorRemunerationDomain";
import { FromToPeriod, NumberField, YesNoQuestion } from "../common/commonComponents";
import { VBox } from "../../components-v2/Box";
import { TextInput } from "../../components-v2/TextInput";
import { CURRENCY_NOK } from "../../utils/currency";
import { when } from "../../utils/functions";

import { useTranslation } from "../../stores/RootStoreContext";

export const ApproveAuditorRemunerationView = observer(function ApproveAuditorRemunerationView({
  form,
}: {
  form: ApproveAuditorRemunerationForm;
}) {
  const { t } = useTranslation();

  return (
    <VBox gap={"md"}>
      <YesNoQuestion
        question={t("decisions.approveAuditorRemuneration.receive-remuneration-invoice.question")}
        field={form.isCoveredByInvoice}
        isLocked={form.isProjectLocked}
      />
      {form.showSpecifiedValueInput && (
        <NumberField
          label={t("decisions.enter-amount")}
          prefix={CURRENCY_NOK}
          field={form.specifiedValue}
          isLocked={form.isProjectLocked}
          inline
        />
      )}
      <YesNoQuestion
        question={t("decisions.approveAuditorRemuneration.deviating-accounting-year")}
        field={form.isDeviatingPeriod}
        fieldName="approveAuditorRemunerationIsDeviatingPeriod"
        isLocked={form.isProjectLocked}
      />
      {form.showRegularPeriodInput && (
        <VBox>
          <div>{t("decisions.approveAuditorRemuneration.what-accounting-year")}</div>
          <TextInput
            value={form.period.inputValue}
            error={!form.period.isValid}
            readOnly={form.isProjectLocked}
            onChange={form.period.setInputValue}
            onBlur={form.period.commit}
            message={when(form.period.error, t)}
            inline
          />
        </VBox>
      )}
      {form.showDeviatingPeriodInput && (
        <FromToPeriod
          label={t("decisions.approveAuditorRemuneration.what-accounting-period")}
          from={form.deviatingPeriodFrom}
          to={form.deviatingPeriodTo}
          isLocked={form.isProjectLocked}
        />
      )}
    </VBox>
  );
});
